<template>
  <InfoQ :question="question" v-if="question.QuestionType === 1"></InfoQ>
  <ConfirmQ :question="question" v-else-if="question.QuestionType === 2"></ConfirmQ>
  <SelectQ :question="question" v-else-if="question.QuestionType === 3"></SelectQ>
  <InputQ :question="question" v-else-if="question.QuestionType === 4"></InputQ>
  <FileUploadQ :question="question" v-else-if="question.QuestionType === 5"></FileUploadQ>
</template>

<script>
import FileUploadQ from '@/modules/delivery-inspection/components/QuestionTypes/FileUploadQ'
import ConfirmQ from '@/modules/delivery-inspection/components/QuestionTypes/ConfirmQ'
import InfoQ from '@/modules/delivery-inspection/components/QuestionTypes/InfoQ'
import SelectQ from '@/modules/delivery-inspection/components/QuestionTypes/SelectQ'
import InputQ from '@/modules/delivery-inspection/components/QuestionTypes/InputQ'

export default {
  data () {
    return {}
  },
  props: ['question'],
  components: {
    FileUploadQ,
    InputQ,
    InfoQ,
    SelectQ,
    ConfirmQ
  }
}
</script>

<style>

</style>
